/* eslint-disable max-len */
import React from 'react'
import { OuterWrapper, InnerWrapper, CommonP } from './GlobalStyles';

export const AboutMe = () => {
  return (
    <OuterWrapper>
      <InnerWrapper>
        <CommonP> Hello! I am a Frontend developer with background in translation and interpretation as well as teaching and education.
                  I am aiming to go fullstack and to work on projects that will help people in the future.
                  Environmental protection is my passion and games my hobby, and I hope to be able to work with both during my career in tech!
        </CommonP>
      </InnerWrapper>
    </OuterWrapper>
  );
};

